module.exports = __webpack_public_path__ + "static/media/note3.1d06e8fe.png";